import { __awaiter, __generator } from "tslib";
import { addNcpcCode } from '@ekuaibao/lib/lib/addNcpcCode';
import { app, callback } from '../index.v0';
import { newHomeConfig } from '../newHomeConfig';
import KDCloudSDK from '@ekuaibao/sdk-bridge/sdk/kdcloud';
import registerAPI from '../registerAPI';
import { initializeTitle } from '../initializeTitle';
import initPlatformInfo from '../initPlatformInfo';
import registerHandler from '../registerHandler';
import { initRoute } from '../initRoute';
import { initColors } from '../initColors';
import setNetworkAdapter from '../setNetworkAdapter';
import registerKdCloudAPI from './registerKdCloudAPI';
import initLogger from '../../logger/initLogger';
initLogger();
window.__PLANTFORM__ = 'KD_CLOUD';
function startup() {
    app.use({
        id: '@kdcloud',
        onready: function () {
            addNcpcCode();
        }
    });
    callback();
}
function modifierKey(e) {
    var modifier = 0;
    if (e.metaKey) {
        modifier |= 1;
    }
    if (e.ctrlKey) {
        modifier |= 2;
    }
    if (e.altKey) {
        modifier |= 4;
    }
    if (e.shiftKey) {
        modifier |= 8;
    }
    return modifier;
}
window.addEventListener('keydown', function (e) {
    var modifier = modifierKey(e);
    if (e.keyCode === 82 && (modifier === 1 || modifier === 2)) {
        window.location.reload();
    }
});
export var bootstrap = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                initColors();
                app.container.set('IDeviceType', 'DESKTOP');
                app.container.set('ISMessageEntry', false);
                app.sdk = app.container.get(KDCloudSDK);
                registerHandler();
                return [4, app.sdk.initialize()];
            case 1:
                _a.sent();
                initRoute();
                initPlatformInfo();
                return [4, newHomeConfig()];
            case 2:
                _a.sent();
                registerAPI();
                registerKdCloudAPI();
                startup();
                initializeTitle();
                setNetworkAdapter();
                return [2];
        }
    });
}); };
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'beta') {
    require('../development');
}
